<template>
  <div
    v-cloak
    v-loading.fullscreen.lock="dataLoading"
    element-loading-text="Loading, please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div>
      <!--<i class="el-icon-arrow-left"></i>-->
      <!--<span class="title">My To Do List</span>-->
    </div>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }">
            <i class="fa fa-home"></i> Home
          </router-link>
        </li>
        <li class="active">
          <small>Tag Mgmt.</small>
        </li>
      </ol>
    </div>

    <confirmation-box ref="deleteAbstractDialog" @handleConfirm="confirmToremove"></confirmation-box>

    <confirmation-box ref="deleteInstanceDialog" @handleConfirm="confirmToremoveInstance"></confirmation-box>

    <add-abstract-tag
      :abstractParentId="abstractParentId"
      ref="addAbstractTagDialog"
      @saveSuccess="getAbstractTree"
    ></add-abstract-tag>

    <edit-abstract-tag
      ref="editAbstractTagDialog"
      :editAbstractTagDO="editAbstractTagDO"
      @saveSuccess="getAbstractTree"
    ></edit-abstract-tag>

    <add-instance-tag
      :instanceParentId="instanceParentId"
      ref="addInstanceTagDialog"
      @saveSuccess="getInstanceTree"
    ></add-instance-tag>

    <edit-instance-tag
      ref="editInstanceTagDialog"
      :editInstanceTagDO="editInstanceTagDO"
      @saveSuccess="getInstanceTree"
    ></edit-instance-tag>

    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Abstract">
          <!-- <el-collapse v-model ="activeNames"> -->
          <h5>Tag Abstract</h5>
          <el-row>  
            <el-col :span="24">
              <div class="area">
                <div class="area-1">
                  <el-row :gutter="20">
                    <el-col :span="18">
                      <el-form ref="queryForm" label-width="100px" label-position="right">
                        <el-form-item label="功能名称：" style="margin-bottom:5px">
                          <!--prop校验-->
                          <el-input v-model="searchAbstractValue" size="small"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="6">
                      <div class="text-left button-auto" style="margin-top: 7px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="searchForAbstractTree()"
                        >Search</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="23">
                      <div class="text-right button-auto2" style="margin-bottom: 10px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addAbstractTag()"
                          :disabled="addAbstractDisabled"
                        >Add</el-button>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="editAbstractTag()"
                          :disabled="editAbstractDisabled"
                        >Edit Selected</el-button>
                        <!--                        <el-button type="primary" size="mini" @click="saveAbstractStructure()">Save Structure</el-button>-->
                        <el-button
                          type="danger"
                          size="mini"
                          @click="deleteAbstractTag()"
                          :disabled="deleteAbstractDisabled"
                        >Delete Checked List</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="area-2">
                  <el-row :gutter="20">
                    <el-col style="width:99%;padding-right:0px">
                      <tree-control
                        ref="abstractTree"
                        :showCheckbox="showAbstractCheckbox"
                        @nodeClick="abstractNodeClick"
                      ></tree-control>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- </el-collapse>  -->
        </el-tab-pane>

        <el-tab-pane label="Instance">
          <h5>Tag Instance</h5>
          <el-row>
            <el-col :span="24">
              <div class="area">
                <div class="area-1">
                  <el-row :gutter="20">
                    <el-col :span="18">
                      <el-form ref="queryForm" label-width="100px" label-position="right">
                        <el-form-item label="功能名称：" style="margin-bottom:5px">
                          <!--prop校验-->
                          <el-input v-model="searchInstanceValue" size="small"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="6">
                      <div class="text-left button-auto" style="margin-top: 7px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="searchForInstanceTree()"
                        >Search</el-button>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="23">
                      <div class="text-right button-auto2" style="margin-bottom: 10px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addInstanceTag()"
                          :disabled="addInstanceDisabled"
                        >Add</el-button>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="editInstanceTag()"
                          :disabled="editInstanceDisabled"
                        >Edit Selected</el-button>
                        <!--                        <el-button type="primary" size="mini" @click="saveInstanceStructure()">Save Structure</el-button>-->
                        <el-button
                          type="danger"
                          size="mini"
                          @click="deleteInstanceTag()"
                          :disabled="deleteInstanceDisabled"
                        >Delete Checked List</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="area-2">
                  <el-row :gutter="20">
                    <el-col :span="23">
                      <tree-control
                        ref="instanceTree"
                        :showCheckbox="showInstanceCheckBox"
                        @nodeClick="instanceNodeClick"
                      ></tree-control>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import confirmationBox from "@/components/dialog/confirmation_box.vue";
import treeControl from "@/view/acs/tree/tree_control.vue";
import treeSelect from "@/view/acs/tree/tree_selection.vue";

import addAbstractTag from "@/view/acs/tag/dialog/add_abstract_tag.vue";
import editAbstractTag from "@/view/acs/tag/dialog/edit_abstract_tag.vue";

import addInstanceTag from "@/view/acs/tag/dialog/add_instance_tag.vue";
import editInstanceTag from "@/view/acs/tag/dialog/edit_instance_tag.vue";

// import instanceTagTable from '@/view/acs/tag/dialog/instance_tag_table.vue'

export default {
  props: {},
  components: {
    editAbstractTag,
    addAbstractTag,
    confirmationBox,
    treeControl,
    treeSelect,
    addInstanceTag,
    editInstanceTag
    // instanceTagTable
  },
  data() {
    return {
      searchAbstractValue: "",
      dataLoading: false,
      activeNames: ["1"],
      showAbstractCheckbox: false,
      abstractParentId: "0",
      editAbstractTagDO: {},
      searchInstanceValue: "",
      showInstanceCheckBox: false,
      instanceParentId: "0",
      editInstanceTagDO: {},
      addInstanceDisabled: true,
      editInstanceDisabled: true,
      deleteInstanceDisabled: true,
      addAbstractDisabled: true,
      editAbstractDisabled: true,
      deleteAbstractDisabled: true
    };
  },
  computed: {},
  created() {
    this.initTree();
  },
  methods: {
    initTree() {
      // @TODO： instance-tree
      let abstractUrl =
        this.baseAcsUrl + "/acs/data-abstract-tag/get-tree";
      let instanceUrl =
        this.baseAcsUrl + "/acs/data-instance-tag/get-tree";
      let that = this;
      this.dataLoading = true;
      this.axios
        .all([that.http.get(abstractUrl), that.http.get(instanceUrl)])
        .then(
          this.axios.spread(function(abstractResp, instanceResp) {
            that.dataLoading = false;
            let abstractData = abstractResp.data;
            let instanceRespData = instanceResp.data;
            if (abstractData) {
              that.$refs.abstractTree.initTree(abstractData, "tagName");
            }
            if (instanceRespData) {
              that.$refs.instanceTree.initTree(instanceRespData, "tagName");
            }
          })
        )
        .catch(error => {
          console.error(error);
          that.dataLoading = false;
        });
    },
    getAbstractTree() {
      let url = this.baseAcsUrl + "/acs/data-abstract-tag/get-tree";
      this.dataLoading = true;
      this.http
        .get(url)
        .then(resp => {
          //this.structure = resp.data;
          this.$refs.abstractTree.initTree(resp.data, "tagName");
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    getInstanceTree() {
      let url = this.baseAcsUrl + "/acs/data-instance-tag/get-tree";
      this.dataLoading = true;
      this.http
        .get(url)
        .then(resp => {
          //this.structure = resp.data;
          this.$refs.instanceTree.initTree(resp.data, "tagName");
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },

    abstractNodeClick(data) {
      // Nothing to do
      console.log(data);
      this.addAbstractDisabled = data.id == 0;
      this.editAbstractDisabled = data.id == 0;
      this.deleteAbstractDisabled = data.id == 0;
    },
    searchForAbstractTree() {
      this.$refs.abstractTree.filter(this.searchAbstractValue);
    },
    searchForInstanceTree() {
      this.$refs.instanceTree.filter(this.searchInstanceValue);
    },

    addAbstractTag() {
      this.abstractParentId = this.$refs.abstractTree.getFunctionNodeKey();
      this.$refs.addAbstractTagDialog.showDialog();
    },
    editAbstractTag() {
      this.editAbstractTagDO = this.$refs.abstractTree.getCurrentNode();
      this.$refs.editAbstractTagDialog.showDialog();
    },
    saveAbstractStructure() {
      let dataStructure = this.$refs.abstractTree.getDataStructure();
      let url = this.baseAcsUrl + "/acs/data-abstract-tag/update";

      if (!dataStructure && dataStructure.length == 0) {
        this.$message.warning("Please save at least one record");
        return;
      }
      for (let i in dataStructure) {
        dataStructure[i].abstractParentId = null;
      }
      this.dataLoading = true;
      this.http
        .put(url, dataStructure)
        .then(resp => {
          this.$message.success("Successful operation ");
          this.getAbstractTree();
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    deleteAbstractTag() {
      this.$refs.deleteAbstractDialog.showDialog();
    },
    confirmToremove() {
      let selections = this.$refs.abstractTree.getCheckedKeys();
      if (!selections || !selections.length) {
        this.$message.warning("Select record please");
        return;
      }
      let url = this.baseAcsUrl + "/acs/data-abstract-tag/delete";
      this.dataLoading = true;
      this.http
        .delete(url, selections)
        .then(resp => {
          this.dataLoading = false;
          this.$refs.deleteAbstractDialog.hideDialog();
          this.$message.success("Successful operation");
          this.getAbstractTree();
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    confirmToremoveInstance() {
      let selections = this.$refs.instanceTree.getCheckedKeys();
      if (!selections || !selections.length) {
        this.$message.warning("Select record please");
        return;
      }
      let url = this.baseAcsUrl + "/acs/data-instance-tag/delete";
      this.dataLoading = true;
      this.http
        .delete(url, selections)
        .then(resp => {
          this.dataLoading = false;
          this.$refs.deleteInstanceDialog.hideDialog();
          this.$message.success("Successful operation");
          this.getInstanceTree();
        })
        .catch(error => {
          this.dataLoading = false;
          console.error(error);
        });
    },
    addInstanceTag() {
      this.instanceParentId = this.$refs.instanceTree.getCurrentNode().instanceParentId;
      this.$refs.addInstanceTagDialog.showDialog();
    },
    editInstanceTag() {
      this.editInstanceTagDO = this.$refs.instanceTree.getCurrentNode();
      this.$refs.editInstanceTagDialog.showDialog();
    },
    saveInstanceStructure() {
      let dataStructure = this.$refs.instanceTree.getDataStructure();
      console.log(dataStructure);
    },
    deleteInstanceTag() {
      this.$refs.deleteInstanceDialog.showDialog();
    },
    instanceNodeClick(nodeData) {
      // Nothing to do
      console.log(nodeData);
      this.addInstanceDisabled = nodeData.isService != 0;
      this.editInstanceDisabled = nodeData.isService != 2;
      this.deleteInstanceDisabled = nodeData.isService != 2;
      //
      // let abstractTagId = '';
      //
      // let getNextNodeUrl = this.baseAcsUrl + "/acs/data-instance-tag/get-data-tag-tab";
      // if(nodeData.isService == 1 || nodeData.id == 0){
      //   return;
      //
      //
      // }else if(nodeData.isService == 0){
      //
      //
      // }else{
      //   abstractTagId = nodeData.id;
      //
      // }
      // getNextNodeUrl += "?data_tag_id =" + abstractTagId;
      //
      // this.dataLoading = true;
      // this.http.get(getNextNodeUrl).then(resp =>{
      //   let data = resp.data;
      //   if(data){
      //     nodeData.children =data;
      //     console.log(nodeData);
      //   }
      //   this.dataLoading =false;
      //
      // }).catch(error =>{
      //   console.error(error);
      //   this.dataLoading =false;
      // })
    }
  }
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 0px;
}
.title {
  margin-left: 16px;
  font-size: 20px;
}

.area {
  margin-top: 10px;
  /*padding: 10px;*/
  border: 1px solid #d1dbe5;
  border-radius: 4px;
  background-color: #f6f8f9;
  overflow: hidden;
  /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);*/
  font-size: 10px;
  .area-2 {
    height: 350px;
    overflow: hidden;
    overflow-y: auto;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/acs/tag/tag_list1.vue